import { useNewTranslation } from 'hooks'
import RectangleButton from 'particles/Button/RectangleButton'
import React from 'react'
import { TemplateDetailSchema } from '../TemplateDetail'
import { CampaignTaskElements } from 'services/api/campaignTemplates'
import { OnFormikValueChangeProps } from '../OnFormikValueChange'
import { ElementKeys } from '../TemplateDetail/options'
export interface TaskElementProps {
    onNext?: (isCompleted: boolean, isError: boolean) => void
    onBack?: () => void
    onSubmit?: () => void
    validateSpecificField: OnFormikValueChangeProps['validateSpecificField']
    updateCurrentStepStatus: (isCompleted: boolean, isError: boolean) => void
    showError?: boolean
    taskOrder: number
    isReadOnly?: boolean
    templateUuid: string | null
    setNavigationDisable: React.Dispatch<React.SetStateAction<boolean>>
    isDisableNavigation: boolean
    openWarningClickToast?: () => void
    campaignTemplateStepKey: ElementKeys
}

export type ErrorTasks = Record<keyof CampaignTaskElements, string>

interface ActionButtonProps
    extends Omit<TaskElementProps, 'showError' | 'updateCurrentStepStatus' | 'setNavigationDisable' | 'isReadOnly'> {
    fieldNames: (keyof CampaignTaskElements)[]
}

const ActionButton = ({
    onBack,
    onNext,
    onSubmit,
    validateSpecificField,
    isDisableNavigation,
    fieldNames,
    taskOrder,
    openWarningClickToast,
}: ActionButtonProps) => {
    const [t] = useNewTranslation()

    const specificFields = fieldNames.map(
        name => `task_elements.${taskOrder}.${name}`,
    ) as (keyof TemplateDetailSchema)[]

    const validateWithCallback = (cb?: (isCompleted: boolean, isError: boolean) => void) => {
        validateSpecificField(specificFields).then(errors => {
            const noError = !Object.keys(errors).length
            if (noError) {
                cb?.(true, false)
            } else {
                const brandHandlesErr =
                    errors[`task_elements.${taskOrder}.brand_handles` as keyof typeof errors] ===
                    t('campaign.template.profileTag.errorMessage.wrongFormate')
                const captionHashtagErr =
                    errors[`task_elements.${taskOrder}.caption_hashtags` as keyof typeof errors] ===
                    t('campaign.template.profileTag.errorMessage.wrongFormate')

                if (brandHandlesErr || captionHashtagErr) {
                    cb?.(false, true)
                } else {
                    cb?.(false, false)
                }
            }
        })
    }

    const onBackStep = () => {
        if (isDisableNavigation) {
            openWarningClickToast?.()
            return
        }
        onBack?.()
    }

    const onNextClick = () => {
        if (isDisableNavigation) {
            openWarningClickToast?.()
            return
        }
        validateWithCallback(onNext)
    }

    const onSubmitForm = () => {
        if (isDisableNavigation) {
            openWarningClickToast?.()
            return
        }
        validateWithCallback(onSubmit)
    }

    return (
        <div className="button-group">
            {!!onBack && (
                <div className="button">
                    <RectangleButton
                        type={'button'}
                        form={'outlined'}
                        size={'l'}
                        label={t('button.back')}
                        onClick={onBackStep}
                    />
                </div>
            )}
            {!!onNext && (
                <div className="button">
                    <RectangleButton type={'button'} size={'l'} label={t('button.next')} onClick={onNextClick} />
                </div>
            )}
            {!!onSubmit && (
                <div className="button">
                    <RectangleButton
                        type={'button'}
                        size={'l'}
                        label={t('button.modalWindow.next')}
                        onClick={onSubmitForm}
                    />
                </div>
            )}
        </div>
    )
}

export default ActionButton
